import React from 'react';
import { Button, Modal, FormControl, FormGroup, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import UserActionCreators from '../../../actions/UserActionCreators';
function getEmptyState() {
    return {
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        password: '',
    };
}
class RegisterUserForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return getEmptyState();
    }
    onChange(key) {
        return (e) => {
            this.setState({ [key]: e.target.value });
        };
    }
    close() {
        this.setState(getEmptyState());
        this.props.onHide();
    }
    register() {
        return (e) => {
            e.preventDefault();
            UserActionCreators.addAdminUser(this.state);
            this.close();
        };
    }
    render() {
        const { t } = this.props;
        var disabled = _.isEmpty(this.state.username) ||
            _.isEmpty(this.state.email) ||
            _.isEmpty(this.state.first_name) ||
            _.isEmpty(this.state.last_name) ||
            _.isEmpty(this.state.password);
        return (React.createElement(Modal, { show: this.props.show, onHide: this.props.onHide },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, t('REGISTER_AN_ADMIN_USER'))),
            React.createElement(Modal.Body, null,
                React.createElement("form", { className: "form-horizontal" },
                    React.createElement(FormGroup, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement("p", null, t('USERNAME'))),
                        React.createElement(Col, { xs: 12 },
                            React.createElement(FormControl, { type: "text", ref: "username", onChange: this.onChange('username'), value: this.state.username }))),
                    React.createElement(FormGroup, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement("p", null, t('EMAIL'))),
                        React.createElement(Col, { xs: 12 },
                            React.createElement(FormControl, { type: "text", ref: "email", placeholder: "example@cargomatic.com", onChange: this.onChange('email'), value: this.state.email }))),
                    React.createElement(FormGroup, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement("p", null, t('FIRST_NAME'))),
                        React.createElement(Col, { xs: 12 },
                            React.createElement(FormControl, { type: "text", ref: "first_name", placeholder: "John", onChange: this.onChange('first_name'), value: this.state.first_name }))),
                    React.createElement(FormGroup, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement("p", null, t('LAST_NAME'))),
                        React.createElement(Col, { xs: 12 },
                            React.createElement(FormControl, { type: "text", ref: "last_name", placeholder: "Smith", onChange: this.onChange('last_name'), value: this.state.last_name }))),
                    React.createElement(FormGroup, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement("p", null, t('PASSWORD'))),
                        React.createElement(Col, { xs: 12 },
                            React.createElement(FormControl, { ref: "password", type: "password", onChange: this.onChange('password'), value: this.state.password }))))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: () => this.close() }, titleize(t('CLOSE'))),
                React.createElement(Button, { bsStyle: "primary", onClick: this.register(), disabled: disabled }, t('REGISTER')))));
    }
}
export default withTranslation()(RegisterUserForm);
